import { ViewModel,View, ObservableArray } from "binder"
import  { DistrictSaleDebtorsAndCreditorsView } from "./districtSaleDebtorsAndCreditors-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class DistrictSaleDebtorsAndCreditorsViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'بدهکاران بستانکاران شعب'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.items = ObservableArray.create<singleLine>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictSaleDebtorsAndCreditorsView();
    }
    public getTypeId(): string {
        return "VM-791DB51D-A2EA-4FF7-B08D-55F03B4A011B"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleLine>) { this._items = v; } public get items(): ObservableArray<singleLine> { return this._items;} private _items: ObservableArray<singleLine>;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/GetCurrentDistrictDebtAndCreditReport',{

            })
            this.items.update(...result.Report.map((x,i)=>{
                let r = new singleLine(this);
                r.index = i+1;
                r.fromName = x.From;
                r.toName = x.To;
                r.amount = x.Amount;
                r.amountString = r.amount>=0 ? r.amount.toString() : `(${-r.amount})`;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class singleLine extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set fromName(v: string) { this._fromName = v; } public get fromName(): string { return this._fromName;} private _fromName: string;
    public set toName(v: string) { this._toName = v; } public get toName(): string { return this._toName;} private _toName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set amountString(v: string) { this._amountString = v; } public get amountString(): string { return this._amountString;} private _amountString: string;
       
}